import { Check } from 'lucide-react'
import type { Tag } from '../lib/api'
import { cn } from '../lib/utils'

interface TagPickerProps {
  tags: Tag[]
  selectedIds: string[]
  onToggle: (id: string) => void
  className?: string
}

export function TagPicker({ tags, selectedIds, onToggle, className }: TagPickerProps) {
  if (tags.length === 0) {
    return (
      <p className={cn('text-xs text-text-tertiary', className)}>
        Noch keine Tags angelegt — gehe zu „Tags“ in der Sidebar.
      </p>
    )
  }
  return (
    <div className={cn('flex flex-wrap gap-1.5', className)}>
      {tags.map((t) => {
        const selected = selectedIds.includes(t.id)
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => onToggle(t.id)}
            aria-pressed={selected}
            aria-label={`Tag ${t.name} ${selected ? 'abwählen' : 'auswählen'}`}
            title={t.name}
            className={cn(
              // touch:min-h-10 lifts the 26px pills to a >=40px tap target on
              // touch devices; desktop keeps the compact size.
              'inline-flex max-w-full items-center gap-1.5 rounded-full px-2.5 py-1 touch:min-h-10 touch:px-3.5 text-xs border transition-all',
              selected ? 'opacity-100' : 'opacity-60 hover:opacity-100',
            )}
            style={{
              backgroundColor: selected ? `${t.color}25` : `${t.color}10`,
              borderColor: selected ? t.color : `${t.color}40`,
              color: t.color,
            }}
          >
            {selected && <Check className="h-3 w-3 shrink-0" strokeWidth={3} />}
            <span className="truncate">{t.name}</span>
          </button>
        )
      })}
    </div>
  )
}
